import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IMediaInterface } from '@lib/vehicle-intelligence/api';

@Component({
  templateUrl: './lpr-plate-image-dialog.component.html',
  styleUrls: ['./lpr-plate-image-dialog.component.scss'],
})
export class LprPlateImageDialogComponent implements OnInit {
  public mediaCarousel: any[] = [];
  public activeMedia: IMediaInterface;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  public ngOnInit(): void {
    if (!this.data.plate) {
      this.data.plate = this.data;
    }
    this.determineContextImage();
  }

  public determineContextImage(): void {
    this.mediaCarousel.push(this.data.thumbnailUrl);
    this.mediaCarousel.sort((x, y) => {
      return x.type === 'context' ? -1 : y.type === 'context' ? 1 : 0;
    });
    this.activeMedia = this.mediaCarousel[0];
  }

  public trackMedia(index: number, mediaFile: IMediaInterface): any {
    return mediaFile.type;
  }

  public setPlaceholderImage(event: any): void {
    event.target.src = '/assets/map-icons/No_Image_Found.png';
  }

  public isActive(media: IMediaInterface): boolean {
    return this.activeMedia && this.activeMedia.thumbnailUrl === media.url;
  }
}
